import { motion } from "framer-motion";
import { ArrowRight } from "lucide-react";
import { FadeIn } from "../ui/FadeIn";

export function CtaSection() {
  return (
    <section id="sumate" className="py-16 sm:py-24">
      <div className="section-shell">
        <FadeIn>
          <div className="rounded-3xl border border-borderSoft bg-white px-6 py-10 text-center shadow-soft sm:px-12">
            <h2 className="text-3xl font-extrabold tracking-tight sm:text-4xl">
              Sumate al equipo +10
            </h2>
            <p className="mx-auto mt-4 max-w-2xl text-base text-ink sm:text-lg">
              Potenciá tu juego con el equipo más completo de asistentes virtuales para
              fútbol.
            </p>
            <motion.a
              href="https://mas10.ar/"
              target="_blank"
              rel="noopener noreferrer"
              className="btn-primary mt-7"
              whileHover={{ scale: 1.03 }}
              whileTap={{ scale: 0.97 }}
            >
              Empezá ahora <ArrowRight size={16} className="ml-2" />
            </motion.a>
          </div>
        </FadeIn>
      </div>
    </section>
  );
}
